export default __webpack_public_path__ + "static/media/learn_grey.5e15ac4c.png";